import styled from 'styled-components';

import { Button } from '@sternum/ui';

export const ButtonStyled = styled(Button)`
  margin: 8px 4px 0;
`;
